<template>
  <div class="inclusion-box p-6">
    <h5 class="font-medium mb-4">All projects include</h5>
    <ul class="grid grid-cols-3 gap-4 sm:grid-cols-1">
      <li v-for="incl in allInclusions" :key="incl.id" class="inclusion-item">
        <div class="flex">
          <img :src="incl.icon_path" :alt="incl.name" />
          <span class="ml-2">{{ incl.name }}</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['allInclusions'])
  }
}
</script>

<style>
.inclusion-box {
  border: 1px solid var(--blue-light-3);
  background-color: var(--blue-light-1);
}

@media (max-width: 600px) {
  .inclusion-box {
    margin: -16px -24px;
    border: none;
  }
}
</style>